import { put, call, cancelled, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  FETCH_START,
  FETCH_END,
  FETCH_ERROR,
  FETCH_CANCEL,
} from 'actions/fetchActions';

const customFetch = (httpClient) => {
  function* handleFetch(action) {
    const { type, payload, meta: { httpMethod, ...meta }, callback } = action;

    yield [
      put({ type: `${type}_LOADING`, payload, meta }),
      put({ type: FETCH_START }),
    ];
    let response;
    try {
      response = yield call(httpClient, httpMethod, meta.apiPath, payload);
      yield put({
        type: `${type}_SUCCESS`,
        payload: response,
        requestPayload: payload,
        meta: { ...meta, customFetchResponse: true, fetchStatus: FETCH_END },
      });
      if (callback) {
        callback();
      }
      yield put({ type: FETCH_END });
    } catch (error) {
      yield put({
        type: `${type}_FAILURE`,
        error: error.message ? error.message : error,
        requestPayload: payload,
        meta: {
          ...meta, customFetchResponse: true, fetchStatus: FETCH_ERROR,
          httpStatus: error.status
        },
      });
      yield put({ type: FETCH_ERROR, error });
    } finally {
      if (yield cancelled()) {
        yield put({ type: FETCH_CANCEL });
      }
    }
  }

  return function* watchCrudFetch() {
    yield [
      takeLatest(action => action.meta && action.meta.httpMethod && action.meta.cancelPrevious, handleFetch),
      takeEvery(action => action.meta && action.meta.httpMethod && !action.meta.cancelPrevious, handleFetch),
    ];
  };
};


export default customFetch;



// WEBPACK FOOTER //
// ./src/sideEffect/saga/customFetch.js